import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    TextField,
    Button,
    IconButton,
    Box,
    Snackbar,
    Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Landingpage from "./page"

export default function CampaignForm() {
    const [open, setOpen] = useState(true);
    const [snackOpen, setSnackOpen] = useState(false);

    const [wappType, setWappType] = useState('');
    const [image, setImage] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [message, setMessage] = useState('');

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) setImage(URL.createObjectURL(file));
    };

    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file) setVideoFile(file);
    };

    const handlePdfChange = (e) => {
        const file = e.target.files[0];
        if (file) setPdfFile(file);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('wappType', wappType);
        formData.append('message', message);
        if (image) formData.append('image', image);
        if (videoFile) formData.append('video', videoFile);
        if (pdfFile) formData.append('pdf', pdfFile);

        console.log('Form submitted with:');
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }

        setSnackOpen(true);
        setOpen(false);
    };

    return (
        <>
            <Landingpage />
            {/* <Box sx={{ bgcolor: "#b2ebf2", minHeight: "100vh", p: 3 }}> */}
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        // bgcolor: '#e3f2fd', 
                        borderRadius: 2,
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 'bold',
                        color: '#0D47A1',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        bgcolor: '#b2ebf2',
                    }}
                >
                    Campaign Details
                    <IconButton onClick={() => setOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <DialogContent
                        dividers
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            // bgcolor: '#e3f2fd',
                        }}
                    >
                        <Box>
                            <Typography fontWeight="bold" mb={1}>WAPP Type</Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter WAPP Type"
                                value={wappType}
                                onChange={(e) => setWappType(e.target.value)}
                            />
                        </Box>

                        <Box>
                            <Typography fontWeight="bold" mb={1}>Image Upload</Typography>
                            <input type="file" accept="image/*" onChange={handleImageChange} />
                            {image && (
                                <Box
                                    component="img"
                                    src={image}
                                    alt="Preview"
                                    sx={{
                                        width: '100px',
                                        height: '100px',
                                        mt: 2,
                                        borderRadius: 2,
                                        border: '1px solid #ccc'
                                    }}
                                />
                            )}
                        </Box>

                        <Box>
                            <Typography fontWeight="bold" mb={1}>Video Upload</Typography>
                            <input type="file" accept="video/*" onChange={handleVideoChange} />
                            {videoFile && <Typography variant="body2" mt={1}>{videoFile.name}</Typography>}
                        </Box>

                        <Box>
                            <Typography fontWeight="bold" mb={1}>PDF Upload</Typography>
                            <input type="file" accept="application/pdf" onChange={handlePdfChange} />
                            {pdfFile && <Typography variant="body2" mt={1}>{pdfFile.name}</Typography>}
                        </Box>

                        <Box>
                            <Typography fontWeight="bold" mb={1}>Message</Typography>
                            <TextField
                                fullWidth
                                multiline
                                minRows={4}
                                placeholder="Enter your message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button
                            onClick={() => setOpen(false)}
                            variant="outlined"
                            sx={{
                                color: '#f44336',
                                borderColor: '#f44336',
                                fontWeight: 'bold',
                                borderRadius: 2,
                                textTransform: 'none',
                                transition: '0.3s',
                                '&:hover': {
                                    backgroundColor: '#f44336',
                                    color: '#fff',
                                    borderColor: '#f44336',
                                    boxShadow: '0 4px 10px rgba(244, 67, 54, 0.3)',
                                },
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                background: 'linear-gradient(45deg, #1976d2 30%, #64b5f6 90%)',
                                color: '#fff',
                                fontWeight: 'bold',
                                borderRadius: 2,
                                textTransform: 'none',
                                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
                                transition: '0.3s',
                                '&:hover': {
                                    background: 'linear-gradient(45deg, #1565c0 30%, #42a5f5 90%)',
                                    boxShadow: '#01579b',
                                },
                            }}
                        >
                            Submit
                        </Button>
                    </DialogActions>

                </form>
            </Dialog>

            <Snackbar
                open={snackOpen}
                autoHideDuration={4000}
                onClose={() => setSnackOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="success" sx={{ width: '100%' }}>
                    Campaign submitted successfully!
                </Alert>
            </Snackbar>
            {/* </Box> */}
        </>
    );
}
